var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Rewards Page")]),_vm._v(" "),_c('canvas',{ref:"canvas",staticStyle:{"background":"black"},attrs:{"id":"canvas1"}})])}
var staticRenderFns = []

export { render, staticRenderFns }